import React from "react";
import { BookOpen, Target, Wrench, Award, ChevronRight } from "lucide-react";

const HowSection = () => {
  const steps = [
    {
      num: "01",
      title: "Learn Concepts",
      description: "Understand key ideas through interactive lessons and demonstrations.",
      themeClass: "p-purple",
      icon: <BookOpen />
    },
    {
      num: "02",
      title: "Practice Skills",
      description: "Apply learning through guided activities and challenges.",
      themeClass: "p-blue",
      icon: <Target />
    },
    {
      num: "03",
      title: "Build Projects",
      description: "Create real-world projects using modern tools and technologies.",
      themeClass: "p-pink",
      icon: <Wrench />
    },
    {
      num: "04",
      title: "Showcase Success",
      description: "Present projects, earn certificates and take part in competitions.",
      themeClass: "p-orange",
      icon: <Award />
    }
  ];

  return (
    <section className="section how section-shaded" id="how">
      <div className="container">
        <div className="section-header reveal-triggered fade-up active" data-aos="fade-up">
          <h2>A Structured <span className="text-gradient">Learning Journey</span></h2>
          <p>A simple 4-step process to develop future-ready skills.</p>
        </div>

        <div className="how-journey reveal-triggered fade-up active" data-aos="zoom-in" data-aos-delay="150">
          {steps.map((step, index) => (
            <React.Fragment key={index}>
              {/* Journey Step */}
              <div className="journey-step" data-aos="zoom-in" data-aos-delay={(index + 1) * 150}>
                <div className={`step-card-box ${step.themeClass}`}>
                  {step.icon}
                  <div className="step-badge">{step.num}</div>
                </div>
                <div className="step-details">
                  <h3>{step.title}</h3>
                  <p>{step.description}</p>
                </div>
              </div>

              {/* Journey Arrow between steps */}
              {index < steps.length - 1 && (
                <div className="journey-arrow" data-aos="fade-right" data-aos-delay={(index + 1) * 150}>
                  <ChevronRight />
                </div>
              )}
            </React.Fragment>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowSection;
